import { render, staticRenderFns } from "./qmatriz.vue?vue&type=template&id=679ae7b4&scoped=true&"
import script from "./qmatriz.vue?vue&type=script&lang=js&"
export * from "./qmatriz.vue?vue&type=script&lang=js&"
import style0 from "./qmatriz.vue?vue&type=style&index=0&id=679ae7b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ae7b4",
  null
  
)

export default component.exports